<template>
  <div class="audio-visualizer" :class="{ active: isActive }">
    <div class="visualizer-bars">
      <div v-for="n in 5" :key="n" class="bar"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BSPAudioVisualizer",
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.audio-visualizer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  opacity: 0.5;
  transition: opacity 0.3s ease;

  &.active {
    opacity: 1;
  }
}

.visualizer-bars {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 24px;
}

.bar {
  width: 4px;
  height: 100%;
  background-color: $orange;
  border-radius: 2px;
  animation: pulse 1s ease-in-out infinite;

  @for $i from 1 through 5 {
    &:nth-child(#{$i}) {
      animation-delay: $i * 0.1s;
    }
  }
}

@keyframes pulse {
  0% {
    transform: scaleY(0.3);
  }
  50% {
    transform: scaleY(1);
  }
  100% {
    transform: scaleY(0.3);
  }
}
</style>
